import React, { useContext } from 'react';

import { AuthContext } from '@/contexts';
import { useGetCurrentUserQuery } from '@/services';

interface UserAvatarProps {
  style: string;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ style }) => {
  const { data: user } = useGetCurrentUserQuery(true);
  const { currentUserData } = useContext(AuthContext);
  const firstName = currentUserData?.firstName ?? user?.data?.firstName ?? '';
  const lastName = currentUserData?.lastName ?? user?.data?.lastName ?? '';
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`;

  return (
    <div className={`flex items-center justify-center rounded-full ${style} p-1`}>{initials}</div>
  );
};
